import React from "react";
import "./LoadingSpinner.css";

export const LoadingSpinner = () => {

    return (
        <div id="html-spinner"></div>
    )
};